<template>
  <div class="lesson-item-box">
    <div class="lesson-item-header">
      <div class="lesson-item-header-content">
        <div class="container lesson-item-header-top">
          <div class="lesson-item-header-title">
            <el-breadcrumb separator="/" style="margin-bottom:10px">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path:'/personal/lesson'}">个人中心</el-breadcrumb-item>
              <el-breadcrumb-item>课程详情</el-breadcrumb-item>
            </el-breadcrumb>
            <h2 class="title">{{ lessonInfo.lessonName }}</h2>
            <ul class="describe">
              <li>
                任课老师 :
                <span>{{ lessonInfo.createUserName }}</span>
              </li>
              <li>
                创建时间 :
                <span>{{ lessonInfo.createTime }}</span>
              </li>
              <li>
                备注 :
                <span>学习重点</span>
              </li>
            </ul>
            <div class="body">
              <p>课程简介 : {{ lessonInfo.summary }}</p>
              <p>
                <span style="margin-right:30px" v-if="lessonInfo.credits">{{ `学分 : ${lessonInfo.credits || 0}` }}</span>
                <span v-if="lessonInfo.periods">{{ `课时 : ${lessonInfo.periods || 0}` }}</span>
              </p>
            </div>
          </div>
          <div class="lesson-item-header-tools">
            <div class="lesson-item-header-btns">
              <el-button type="text" icon="el-icon-s-data" @click="courseAnalysis">数据分析</el-button>
              <!-- $router.push(`/lesson/${lessonInfo.uid}/coursedata`)  -->
              <!-- <el-button type="text" icon="el-icon-star-off">收藏</el-button>
<el-button type="text" icon="el-icon-star-on">取消收藏</el-button>
              <el-button type="text" icon="el-icon-share">分享</el-button>-->
            </div>
            <!-- <div class="lesson-item-header-action">
  <img src="~@/assets/imgs/03.jpg">
  <p>邀请码 : <span>{{ lessonInfo.lessonCode }}</span></p>
            </div>-->
          </div>
        </div>
      </div>
      <div class="menu-btns">
        <div class="container detail-menus">
          <el-menu mode="horizontal" :default-active="activeIndex" @select="handleSelect">
            <el-menu-item v-for="item in menus" :key="item.key" :index="item.key">
              {{ item.text }}
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="container">
      <component :can-edit="canEdit" :can-study="canStudy" :uid="uid" :lessonInfo="lessonInfo" :is="curComponent" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getDetail } from "@/api/lab/lesson";
import lessonExp from "./exp/lesson-exp";
import lessonTask from "./task/lesson-tasks";
import lessonTopic from "./components/lesson-topic";
import lessonResources from "@/views/lesson/resources";
import lessonTest from "./components/lesson-test";
import lessonNotice from "./components/lesson-notice";
import lessonMember from "./components/lesson-member";
import lessonGroup from "./components/lesson-group";

export default {
  data() {
    return {
      uid: "",
      // 课堂详细信息
      lessonInfo: {},
      activeIndex: "exp",
    };
  },
  components: {
    lessonExp,
    lessonTask,
    lessonTopic,
    lessonResources,
    lessonTest,
    lessonNotice,
    lessonMember,
    lessonGroup,
  },
  computed: {
    ...mapGetters(["userInfo", "isStudent", "isTeacher", "isAdmin"]),
    menus() {
      const { roles } = this.userInfo;
      let menus = [
        { key: "exp", text: "实验", component: "lessonExp" },
        { key: "task", text: "作业", component: "lessonTask" },
        { key: "notice", text: "公告", component: "lessonNotice" },
      ];
      if (
        roles &&
        // roles.indexOf(1) > -1 ||  成员列表只能发布者看
        // roles.indexOf(2) > -1
        this.lessonInfo.createUser === this.userInfo.id
      ) {
        menus.push({
          key: "member",
          text: "成员",
          component: "lessonMember",
        });
      }
      return menus;
    },
    curComponent() {
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i].key === this.activeIndex) {
          return this.menus[i].component;
        }
      }
      return this.menus[0].component;
    },
    canEdit() {
      return this.userInfo.id === this.lessonInfo.createUser;
    },
    canStudy() {
      return this.isStudent || this.isTeacher;
    },
  },
  created() {
    const { path, params } = this.$route;
    const { uid, type } = params;
    this.uid = uid;
    if (type) {
      this.activeIndex = type;
    }
    if (path !== `/lesson/${uid}/type/${this.activeIndex}`) {
      this.$router.push(`/lesson/${uid}/type/${this.activeIndex}`);
    }
    this.getEntity(uid);
  },
  methods: {
    courseAnalysis() {
      const { canEdit, lessonInfo, userInfo } = this;
      const { uid } = lessonInfo;
      const { id } = userInfo;
      let url = `/lesson/${uid}/coursedata/${id}`;
      if (canEdit) url = `/lesson/${uid}/coursedata`;
      this.$router.push(url);
    },
    async getEntity(uid) {
      let info = {};
      await getDetail(uid)
        .then((res) => {
          info = res || info;
        })
        .catch(() => {
          this.$router.push("/");
        });
      this.lessonInfo = info;
    },
    // handleSelect(key, keyPath) {
    handleSelect(key) {
      const { uid } = this;
      const { path } = this.$route;
      this.activeIndex = key;
      if (path !== `/lesson/${uid}/type/${key}`) {
        this.$router.push(`/lesson/${uid}/type/${key}`);
      }
    },
  },
};
</script>

<style lang="less">
.lesson-item-box {
  .action-btns {
    & + div {
      margin-top: 20px;
    }

    .el-button {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .lesson-list {
    > div {
      & + div {
        margin-top: 12px;
      }
    }

    .action-btns-right {
      float: right;
    }

    .lesson-title {
      > span {
        & + span {
          margin-left: 10px;
        }
      }
    }

    .lesson-body {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        flex: 1;

        > p {
          & + div {
            margin-top: 10px;
          }
        }

        .word {
          line-height: 30px;
          max-height: 100px;
          font-size: 14px;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        }

        .p {
          color: #5b5b5b;
          line-height: 1.8;
        }

        .time {
          > span {
            &.item {
              font-size: 12px;
              color: #2d2d2d;

              > b {
                font-weight: normal;
              }

              &.group-name {
                padding-left: 8px;
                border-left: 1px solid;
              }
            }

            & + span {
              margin-left: 10px;
            }
          }
        }

        & + div {
          padding-left: 20px;
        }
      }
    }
  }

  .total-cont {
    p {
      font-size: 0;
      line-height: 20px;
      border-left: 1px solid #c8c8c8;
      text-align: center;
      float: left;
      cursor: pointer;

      &:first-child {
        &:hover {
          a {
            &:first-child {
              color: #32c76e;
            }
          }
        }
      }

      &:nth-child(2) {
        &:hover {
          a {
            &:first-child {
              color: #818181;
            }
          }
        }
      }

      &:last-child {
        &:hover {
          a {
            &:first-child {
              color: #e03838;
            }
          }
        }
      }

      a {
        display: block;
        min-width: 80px;
        padding-left: 15px;
        color: #2d2d2d;
        padding-right: 15px;

        &:first-child {
          font-size: 30px;
          height: 44px;
          line-height: 44px;
        }

        &:last-child {
          font-size: 14px;
          height: 26px;
          line-height: 26px;
        }
      }
    }

    .green {
      color: #32c76e;
    }

    .red {
      color: #e03838;
    }

    .grey {
      color: #818181;
    }
  }

  .no-content {
    height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 120px;
    background-image: url("~@/assets/imgs/empty.svg");
  }
}
</style>

<style lang="less" scoped>
@import "~@/assets/css/lesson-page.less";
</style>
